export default __webpack_public_path__ + "static/media/kitchen4-afterE-480w.6d5193e5.webp";